import React, { useState } from 'react'; 
import { useNavigate } from 'react-router-dom'; 
import { Card, CardContent, CardHeader, Avatar, Typography, TextField, Button, Grid } from '@mui/material';

export default function CreateCompany({ onSuccess }) {
  const navigate = useNavigate();

  const [name, setName] = useState('');
  const [address, setAddress] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [website, setWebsite] = useState('');

  const SERVER_URL = process.env.REACT_APP_BACKEND_SERVER_URL;

  const postData = async () => {
    try {
      const response = await fetch(`${SERVER_URL}/api/companies`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, address, email, phoneNumber, website })
      });

      if (!response.ok) {
        console.error("Greška API poziva:", await response.text());
        return; 
      }

      // 🔥 Poziv callback-a da parent refreshuje listu
      if (onSuccess) onSuccess();

      // Možeš ostaviti navigate ili ga ukloniti ako parent kontrolise UI
      navigate('/dashboard/CompaniesListAll');

    } catch (error) {
      console.error("Fetch error:", error);
    }
  };

  return (
    <div style={{ backgroundColor: '#00122E', width: '100%', padding: '20px' }}>
      <Grid container justifyContent="center">
        <Card sx={{ maxWidth: 600, width: '100%', backgroundColor: '#00122E', color: '#ffffff', borderRadius: 2, boxShadow: 3 }}>
          <CardHeader
            avatar={<Avatar sx={{ width: 60, height: 60 }}>Firma</Avatar>}
            title={<Typography variant="h6">Nova firma</Typography>}
          />
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField label="Naziv firme" value={name} onChange={(e) => setName(e.target.value)} fullWidth margin="normal" variant="outlined"
                  InputLabelProps={{ style: { color: '#ffffff' } }} InputProps={{ style: { color: '#ffffff' } }} required
                />
                <TextField label="Adresa" value={address} onChange={(e) => setAddress(e.target.value)} fullWidth margin="normal" variant="outlined"
                  InputLabelProps={{ style: { color: '#ffffff' } }} InputProps={{ style: { color: '#ffffff' } }}
                />
                <TextField label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} fullWidth margin="normal" variant="outlined"
                  InputLabelProps={{ style: { color: '#ffffff' } }} InputProps={{ style: { color: '#ffffff' } }}
                />
                <TextField label="Telefon" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} fullWidth margin="normal" variant="outlined"
                  InputLabelProps={{ style: { color: '#ffffff' } }} InputProps={{ style: { color: '#ffffff' } }}
                />
                <TextField label="Web stranica" value={website} onChange={(e) => setWebsite(e.target.value)} fullWidth margin="normal" variant="outlined"
                  InputLabelProps={{ style: { color: '#ffffff' } }} InputProps={{ style: { color: '#ffffff' } }}
                />
              </Grid>
            </Grid>
            <Button variant="contained" sx={{ mt: 3, backgroundColor: '#3949ab' }} onClick={postData}>
              Spasi
            </Button>
          </CardContent>
        </Card>
      </Grid>
    </div>
  );
}
